import React from 'react'
import PropTypes from 'prop-types'
import find from 'lodash/find'
import FormSwitch from './bases/FormSwitch'
import { updateItemArrayByKey } from 'helpers/arrayHelpers'

const FormAttributeRule = ({
  value,
  mapper,
  onChange,
}) => {
  const handleUpdateByCode = (val, code) => {
    const rule = find(value, ({ code: codeValue }) => code === codeValue)
    if(!rule) {
      return onChange([...value, { code, active: val }])
    }
    return onChange(updateItemArrayByKey(
      value,
      'code',
      code,
      (item) => ({
        ...item,
        active: val,
      })
    ))
  }
  return (
    <div>
      {mapper.map(({ code, active }) => {
        const rule = find(value, ({ code: codeValue }) => code === codeValue) || {}
        return (
          <FormSwitch
            key={code}
            label={code}
            value={rule.active || false}
            onChange={(val) => handleUpdateByCode(val, code)}
          />
        )
      })}
    </div>
  )
}

FormAttributeRule.propTypes = {}
FormAttributeRule.defaultProps = {}

export default FormAttributeRule



// WEBPACK FOOTER //
// ./src/components/forms/FormAttributeRule.js